import { create } from "zustand";
import { devtools } from "zustand/middleware";
import { IndexedDBService } from "../../services/indexedDbService";

const DB_KEY = "creditUserStore";
const db = new IndexedDBService();

export const useCreditStore = create(
  devtools((set, get) => ({
    creditUserStore: null,
    loading: false,

    loadUser: async () => {
      const existing = await db.getItemByKey(DB_KEY);
      if (existing?.value) {
        set({ creditUserStore: existing.value });
      }
    },

    saveUser: async (partialOrFullDraft) => {
      const current = get().creditUserStore || {};
      const updated = {
        ...current,
        ...partialOrFullDraft,
        updatedAt: new Date().toISOString(),
      };
      set({ creditUserStore: updated });
      try {
        await db.setItemByKey(DB_KEY, updated); // persiste
      } catch (err) {
        console.error("Error guardando creditUserStore en IDB:", err);
      }
    },

    // 🔹 Limpiar creditUserStore
    clearUser: async () => {
      await db.deleteItem(DB_KEY);
      set({ creditUserStore: null });
    },
  }))
);
